import React from 'react'
import {
ContainerFluid,Container,HeadingText,ContainerX,ParagraphText,ContainerFluidX
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>
      <ContainerFluid>
        <Container >
          <div className='row'>
            <div className='col s12'>
              <ContainerX>
                <div className='row mt-50 mb-50'>
                  <div className='col s12 m12 l7'>
                    <ContainerX>
                      <br/><br/><br/>
                      <HeadingText className='mt-100'>
                        Keep your money in 
                        Purse. Have access 
                        to it anytime.
                      </HeadingText>
                    </ContainerX>
                    <ContainerX>
                      <div className='row'>
                        <div className='col s12 m12 l10'>
                          <ParagraphText>
                            Are you just looking for where to save your 
                            money without locking it for a certain period
                            before having access to the money. Purse 
                            allows you to save and withdraw at any time. 
                            Just like your regular bank account where 
                            you keep money. 
                          </ParagraphText>
                        </div>
                      </div>
                      
                    </ContainerX>
                  </div>
                  <div className='col s12 m12 center l5'>
                    <ContainerX>
                      <img width="90%" className='' src="https://res.cloudinary.com/yalla-ng/image/upload/v1657141652/PM_4_1_svyxie.svg" alt=""/>
                    </ContainerX>
                  </div>
                </div>
              </ContainerX>
            </div>
          </div>
        </Container>
      </ContainerFluid>
      <ContainerFluidX></ContainerFluidX>
    </div>
  )
}

export default SectionAComponent